import Vue from "vue";
import Vuex from "vuex";

import common from "./modules/common";
import auth from "./modules/auth";
import me from "./modules/me";
import users from "./modules/users";
import rentObjects from "./modules/rentObjects";
import rentObjectTypes from "./modules/rentObjectTypes";
import documentTemplates from "./modules/documentTemplates";
import documentContents from "./modules/documentContents";
import featureTags from "./modules/featureTags";
import rentObjectFeatureTags from "./modules/rentObjectFeatureTags";
import bookingExtras from "./modules/bookingExtras";
import rentObjectBookingExtras from "./modules/rentObjectBookingExtras";
import rentObjectPrices from "./modules/rentObjectPrices";
import rentObjectImages from "./modules/rentObjectImages";
import rentObjectGroundplanImages from "./modules/rentObjectGroundplanImages";
import holidays from "./modules/holidays";
import rentObjectBookings from "./modules/rentObjectBookings";
import customers from "./modules/customers";
import owners from "./modules/owners";
import ownerSettlements from "./modules/ownerSettlements";
import cleaners from "./modules/cleaners";
import commissions from "./modules/commissions";
import bookingStatus from "./modules/bookingStatus";
import emailTemplates from "./modules/emailTemplates";
import emails from "./modules/emails";
import offers from "./modules/offers";
import contracts from "./modules/contracts";
import parentContracts from "./modules/parentContracts";
import payments from "./modules/payments";
import cancelInvoices from "./modules/cancelInvoices";
import rentObjectRatings from "./modules/rentObjectRatings";
import rentObjectBeds from "./modules/rentObjectBeds";
import promotions from "./modules/promotions";
import rentObjectPromotions from "./modules/rentObjectPromotions";
import blocks from "./modules/blocks";
import blockModels from "./modules/blockModels";
import dailyTips from "./modules/dailyTips";
import rentObjectBookingAttachments from "./modules/rentObjectBookingAttachments";
import channels from "./modules/channels";
import rentObjectChannels from "./modules/rentObjectChannels";
import rentObjectLocations from "./modules/rentObjectLocations";
import settings from "./modules/settings";
import bookingRequests from "./modules/bookingRequests";
import addresses from "./modules/addresses";
import paymentReminders from "./modules/paymentReminders";
import medias from "./modules/medias";
import navigationService from "./modules/navigationService";
import financeInvoices from "./modules/financeInvoices";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    auth,
    me,
    users,
    rentObjects,
    rentObjectTypes,
    documentContents,
    documentTemplates,
    featureTags,
    rentObjectFeatureTags,
    bookingExtras,
    rentObjectBookingExtras,
    rentObjectPrices,
    rentObjectImages,
    rentObjectGroundplanImages,
    holidays,
    rentObjectBookings,
    customers,
    owners,
    cleaners,
    commissions,
    bookingStatus,
    emailTemplates,
    emails,
    offers,
    contracts,
    parentContracts,
    payments,
    cancelInvoices,
    rentObjectRatings,
    rentObjectBeds,
    ownerSettlements,
    promotions,
    rentObjectPromotions,
    dailyTips,
    rentObjectBookingAttachments,
    channels,
    rentObjectChannels,
    rentObjectLocations,
    settings,
    bookingRequests,
    addresses,
    blocks,
    blockModels,
    paymentReminders,
    medias,
    navigationService,
    financeInvoices
  },
  strict: true
});
